import React from "react";

export default function () {
  const html = (props) => {
    const needs = props.field.config.needs;
    const { globalState, field } = props;

    React.useEffect(
      () => {
        field.state.value = generateGeneralNeeds();
        props.onUpdate()
      },
      props.field.config.needs.map((m) => props.globalState[m.field])
    );

    const generateGeneralNeeds = () => {
      let tempState = field.config.defaultValue || '';

      needs.forEach((need) => {
        switch (need.validator) {
          case '==':
            if (globalState[need.field]?.includes(need.comparison)) {
              tempState.length == 0 ? tempState += need.output : tempState += ', ' + need.output;
            }
            break;
        }
      });
      return tempState;
    };

    return null;
  };

  return {
    html: html,
    config: {
      invisible: true,
    },
  };
}
